/**
 * 12종 생산기 정의 (PLAN.md 기반)
 */

export interface GeneratorConfig {
  id: string;
  name: string;
  baseCost: number;
  baseProduction: number;
  costMultiplier: number;
  theme: string;
}

export const GENERATORS: GeneratorConfig[] = [
  {
    id: 'gen1',
    name: '스마트폰 채굴',
    baseCost: 10,
    baseProduction: 0.1,
    costMultiplier: 1.15,
    theme: '주머니 속 부업'
  },
  {
    id: 'gen2',
    name: '노트북 채굴',
    baseCost: 100,
    baseProduction: 1,
    costMultiplier: 1.15,
    theme: '카페 코인 농부'
  },
  {
    id: 'gen3',
    name: '데스크탑 채굴',
    baseCost: 1100,
    baseProduction: 8,
    costMultiplier: 1.15,
    theme: 'PC방 알바'
  },
  {
    id: 'gen4',
    name: 'GPU 리그',
    baseCost: 12000,
    baseProduction: 47,
    costMultiplier: 1.15,
    theme: '그래픽카드 대란'
  },
  {
    id: 'gen5',
    name: 'ASIC 채굴기',
    baseCost: 130000,
    baseProduction: 260,
    costMultiplier: 1.15,
    theme: '전문 장비'
  },
  {
    id: 'gen6',
    name: '채굴 농장',
    baseCost: 1.4e6,
    baseProduction: 1400,
    costMultiplier: 1.15,
    theme: '컨테이너 농장'
  },
  {
    id: 'gen7',
    name: '데이터센터',
    baseCost: 20e6,
    baseProduction: 7800,
    costMultiplier: 1.15,
    theme: '기업급 인프라'
  },
  {
    id: 'gen8',
    name: '양자컴퓨터',
    baseCost: 330e6,
    baseProduction: 44000,
    costMultiplier: 1.15,
    theme: '미래 기술'
  },
  {
    id: 'gen9',
    name: 'AI 채굴봇',
    baseCost: 5.1e9,
    baseProduction: 260000,
    costMultiplier: 1.15,
    theme: '자율 채굴'
  },
  {
    id: 'gen10',
    name: '위성 채굴기',
    baseCost: 75e9,
    baseProduction: 1.6e6,
    costMultiplier: 1.15,
    theme: '우주 확장'
  },
  {
    id: 'gen11',
    name: '달 채굴 기지',
    baseCost: 1e12,
    baseProduction: 10e6,
    costMultiplier: 1.15,
    theme: '달 정복'
  },
  {
    id: 'gen12',
    name: '은하 채굴 네트워크',
    baseCost: 14e12,
    baseProduction: 65e6,
    costMultiplier: 1.15,
    theme: '우주 지배'
  }
];

/**
 * 마일스톤: 25/50/75/100/125... 달성 시 생산량 x2
 */
export const MILESTONE_COUNTS = [25, 50, 75, 100, 125, 150, 175, 200];

export function getMilestoneMultiplier(count: number): number {
  let multiplier = 1;
  for (const milestone of MILESTONE_COUNTS) {
    if (count >= milestone) {
      multiplier *= 2;
    }
  }
  return multiplier;
}
